import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { slugify } from "healthex-common/utils";
export const HXMenuItem = (props) => {
    const { analyticsId, children, ...rest } = props;
    const labelFromChildren = React.useMemo(() => {
        const extractText = (node) => {
            return React.Children.toArray(node).flatMap((child) => {
                var _a;
                if (typeof child === "string" || typeof child === "number") {
                    const text = String(child).trim();
                    return text ? [text] : [];
                }
                if (React.isValidElement(child)) {
                    return extractText((_a = child.props) === null || _a === void 0 ? void 0 : _a.children);
                }
                return [];
            });
        };
        const allTexts = extractText(children);
        return allTexts[allTexts.length - 1];
    }, [children]);
    const heapId = analyticsId ? slugify(analyticsId) : labelFromChildren ? slugify(labelFromChildren) : undefined;
    return (_jsx(MenuItem, { "data-heap-id": heapId, ...rest, children: children }));
};
export default HXMenuItem;
